(function () {
	'use strict';

	angular.module('widgets.supplychain')
	.service('projectedShortageService', projectedShortageService);

	function projectedShortageService($http, leanFilterService) {
		return {
			getChartData: getChartData
		};

		function getChartData(settings) {
			var url = '/api/2/factndx/';
			url += leanFilterService.getFactoryList();
			url += '/ProjectedShortages';
			var filterParams = leanFilterService.getQueryParamsObject(true);
			filterParams['itemType'] = settings['itemType'];
			filterParams['bucketType'] = settings['bucketType'];

			url = addQueryParam(url,
				leanFilterService.getFactoryList(), filterParams, false);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}
	}
})();
